import config from "../../config";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import filter from "../../images/icons/filter.png";
import Pagination from "../../components/Pagination";
import editIcon from "../../images/icons/edit.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Modal from "react-bootstrap/Modal";
import viewIcon from "../../images/view.png";
import ExpenseCategoryAdd from "./Add";
import ExpenseCategoryView from "./view.";
import ExpenseCategoryEdit from "./Edit";
import excelIcon from "../../images/icons/excel 1 (1).png";
import { CSVLink } from "react-csv";
import Swal from "sweetalert2";
import DownloadExcel from "../../components/DownloadExcel";

function ExpenseCategoryList() {
  const initialState = {
    exp_cat_name: "",
    exp_cat_type: "",
    is_active: "",
  };
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showId, setShowId] = useState(0);
  const [showEdit, setShowEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const handleEditClose = () => setShowEdit(false);
  const handleEditShow = (id) => {
    setShowEdit(true);
    setEditId(id);
  };
  const [formInputs, setFormInputs] = useState(initialState);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [excelData, setExcelData] = useState([]);

  const [list, setList] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  // const displayList = list.slice(currentPage * 10 - 10, currentPage * 10);

  function changeStatus(exp_cat_id, is_active) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    $.post(
      `${config.apiUrl}/expCategory/cancelExpCategory`,
      JSON.stringify({
        exp_cat_id,
        is_active: is_active,
      }),
    )
      .done(function (res) {
        setError("");
      })
      .catch(function (err) {
        setError(err.responseJSON.data?.message || err.responseJSON.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .always(function () {
        target.innerText = oldText;
        getList();
      });
  }

  async function getList(isFilter = true, pageNo = null) {
    // let json = { paginate: 0 };
    let json = { paginate: 1, page_no: (pageNo || currentPage) - 1 };
    if (isFilter) {
      Object.keys(formInputs).forEach((key) => {
        if (formInputs[key] !== "") {
          json[key] = formInputs[key];
        }
      });
    }
    await $.post(
      `${config.apiUrl}/expCategory/listExpCategory`,
      JSON.stringify(json),
    )
      .done(function (res) {
        // if (isFilter) {
        setCurrentPage(pageNo || currentPage);
        // }
        setIsSubmit(false);
        const data = res.data?.list || res.data || [];
        setList(data);
        setIsLoading(false);
        setTotalPage(
          res.data?.count || res.data?.total_record || res.total_record || 0,
        );

        let listData = [];
        for (let item of data) {
          listData.push({
            Name: item.exp_cat_name,
            Type: item.exp_cat_type,
          });
        }
        setExcelData(listData);
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.responseJSON.data?.message || err.responseJSON.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });
  }

  useEffect(
    function () {
      getList(filtersVisible);
    }, // [show, showEdit, currentPage]
    [currentPage],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 ms-1 p-2">
          <Header />
          <main className="bg-white rounded-4" id="expcat">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Expense Category "]} />
                </div>
                <div className="col text-end">
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2.5rem" }}
                    />
                  </Tippy>
                  <Link
                    onClick={(v) => {
                      handleShow();
                      setShowId(1);
                    }}
                    className="btn btn-primary px-4 py-2"
                  >
                    Add Exp Cat
                  </Link>
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  autoComplete="off"
                >
                  <div className="row" id="expcatAdd">
                    <div className="col-md-2">
                      <label htmlFor="exp_cat_name">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exp_cat_name"
                        value={formInputs.exp_cat_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="exp_cat_type">Type</label>
                      <select
                        type="text"
                        className="form-select"
                        id="exp_cat_type"
                        value={formInputs.exp_cat_type}
                        // onChange={handleInputs}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            exp_cat_type: e.target.value,
                          })
                        }
                      >
                        <option value="">All</option>
                        {config.expenseCategories
                          .filter((item) => [1, 2].includes(item.value))
                          .map((list) => (
                            <option key={list.value} value={list.value}>
                              {list.label}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="status">Status</label>
                      <select
                        className="form-select"
                        id="is_active"
                        name="is_active"
                        value={formInputs.is_active}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_active: e.target.value,
                          })
                        }
                      >
                        {[
                          { id: "", name: "All" },
                          { id: 1, name: "Active" },
                          {
                            id: 0,
                            name: "In-Active",
                          },
                        ].map((v, i) => (
                          <option key={i} value={v.id}>
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 mt-auto">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{ background: "#4263eb", fontSize: "14px" }}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {error && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-danger py-1 small`}
                      role="alert"
                    >
                      {error || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table className={`table ${error ? "my-1" : "mt-4"} rounded`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length === 0) && (
                        <tr>
                          <td colSpan="5" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list.map((v, i) => (
                        <tr key={`ecl_` + i}>
                          <td>{currentPage * 10 - 10 + i + 1}</td>
                          <td>{v.exp_cat_name}</td>
                          <td>
                            {config.expenseCategories.find(
                              (list) => list.value == v.exp_cat_type,
                            )?.label || "N/A"}
                          </td>
                          <td>
                            <Tippy content="Change Status">
                              {v.is_active ? (
                                <span
                                  className="badge text-bg-success"
                                  role="button"
                                  onClick={() => changeStatus(v.exp_cat_id, 0)}
                                >
                                  Active
                                </span>
                              ) : (
                                <span
                                  className="badge text-bg-danger"
                                  role="button"
                                  onClick={() => changeStatus(v.exp_cat_id, 1)}
                                >
                                  In-Active
                                </span>
                              )}
                            </Tippy>
                          </td>
                          <td>
                            <Tippy content="View" trigger="mouseenter">
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(3);
                                }}
                              >
                                <img
                                  src={viewIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </a>
                            </Tippy>
                            <Tippy content="Edit" trigger="mouseenter">
                              <Link
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(2);
                                }}
                                className={`link-info ${
                                  v.is_active ? "" : "d-none"
                                }`}
                              >
                                <img
                                  src={editIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </Link>
                            </Tippy>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    // nPages={Math.ceil(list.length / 10)}
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                backdrop="static"
              >
                {showId == 1 ? (
                  <ExpenseCategoryAdd
                    id={editId}
                    list={getList}
                    hide={handleClose}
                  />
                ) : showId == 2 ? (
                  <ExpenseCategoryEdit
                    id={editId}
                    list={getList}
                    hide={handleClose}
                  />
                ) : showId == 3 ? (
                  <ExpenseCategoryView
                    id={editId}
                    list={getList}
                    hide={handleClose}
                  />
                ) : null}
              </Modal>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default ExpenseCategoryList;
